import { JourneysLegacyAuthRefreshRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// Temporarily handed back to Ember while the Hydra login regression is fixed
// (FPS-2523 — Google login loop). The Hydra login page under @/pages/login is
// intact but unreachable; restore the FPS-2341 route component to re-enable it.
export const Route = createFileRoute('/login/$')({
  component: JourneysLegacyAuthRefreshRoute,
});
